import { validatePaths } from "src/lib/tabs/validateTabs.ts";
import type {
  AdminTabsPersistedState,
  ModuleTabsPersistedState,
} from "src/user-data/types.ts";
import type { Router } from "@remix-run/router";

export const sanitazeModuleLayoutTabs =
  (router: Router) => (data: ModuleTabsPersistedState) => {
    return {
      paths: validatePaths(data.paths, router),
      titles: data.titles,
    };
  };

export const sanitazeAdminLayoutTabs =
  (router: Router) => (data: AdminTabsPersistedState) => {
    return {
      paths: validatePaths(data.paths, router),
      pinnedLeft: data.pinnedLeft.filter((id) =>
        data.paths.find((path) => path.startsWith(id)),
      ),
    };
  };
